/**
 * Settings workstation preview — constants split from classic Workstation Config
 * so preview can evolve independently.
 */

// Todo: Fusion and Multiport port types can be consolidated
export const portTypes = ["independent", "cleaning", "fusion", "multiport"];
export const configurationOptions = ["Whole Bin", "Half Bin", "Quarter Bin"];
export const binSizes = [0, 220, 330, 425];
export const portDirections = ["No Direction", "Inbound", "Outbound"];

// Create an array of numbers from 0 to 4, allowing the array to grow if max(xCoords) > 4
export const possibleGridCoordinates = Array.from(
  { length: 19 },
  (_, i) => i + -9
);
